<template>
  <div class="b1" :class="content.type">
    <div class="actions">
      <div v-for="(c, i) in content.options" :key="i" class="btn btn-outline-light" :class="btnActive(i)" @click="setClass(i+1,c)">{{ c.label }}</div>
    </div>
    
    <button v-if="!chosen" disabled class="btn btn-outline-light btn-lg remix-next">Next</button>
    <div v-for="(t, i) in targets" :key="'tar'+i">
      <router-link v-if="target == t" :to="{ name: 'questions', params: {from: slug, q: getQ(t)} }" class="btn btn-outline-light btn-lg remix-next" :class="disabled">Next</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'content',
    'slug',
  ],
  data() {
    return {
      chosen: false,
      formValue: false,
      target: false,
      formKey: false,
      disabled: "disabled",
    }
  },
  watch: {
    slug(newSlug) {
      this.chosen = false,
      this.target = false,
      this.disabled = 'disabled'
    } 
  },
  methods: {
    setClass( i,c) {
      this.chosen = i;
      this.formValue = c.value;
      this.target = c.target;
      this.formKey = this.content.prop;
      this.disabled = '';
      this.setFormVal({prop: this.formKey, value: this.formValue, group: this.content.group, report: this.totalScore, score: c.score, chosen: this.chosen, serial: c.serial, id: parseInt(this.$router.currentRoute.params.q)});
      this.$store.commit('setNext',this.nextQ);
    },
    btnActive(i){
      return ( i + 1 == this.chosen ) ? 'active' : '';
    },
    getQ(slug) {
      return this.$store.state.content[slug].id;
    },
    setFormVal(payload){
      this.$store.commit('setFormData',payload);
    }
  },
  computed: {
    totalScore() {
      // for max val
      let type = this.content.type;
      let scores = [];
      this.content.options.forEach((v)=>{
        let score = v.score ? v.score : 0;
        scores.push(score);
      });
      return (Math.max.apply(null, scores) > 0) ? Math.max.apply(null, scores) : false;
    },
    nextQ() {
      let con = this.content;
      return this.chosen ? this.getQ(con.options[this.chosen - 1].target) : this.getQ(con.options[0].target);
    },
    targets() {
      let opt = this.content.options;
      let tar = [];
      opt.forEach(function(v){
        tar.push(v.target);
      });
      return Array.from(new Set(tar));
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log('hello update');
    // this.id = parseInt(to.params.q, 10);
    // this.from = to.params.from;
    // this.getContent();
    this.chosen = false;
    //console.log(from);
    next();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars';
@import '../../assets/scss/mixins';

.actions {
  margin-bottom: gu(2);
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 40rem) {
    margin-bottom: gu(3);
    flex-direction: row;
  }
}

.btn:not(.remix-next) {
  margin-bottom: gu(0.5);
  
  @media only screen and (min-width: 40rem) {
    margin-bottom: 0;
  }

  &:first-child {

    @media only screen and (min-width: 40rem) {
      margin-right: rem-calc(0.5);
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  &:last-child {

    @media only screen and (min-width: 40rem) {
      margin-left: rem-calc(0.5);
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  &.active {
    background:  $colTeal;
    color: white;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

</style>
